import { Action, ThunkAction, combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { listingOptionsReducer } from './listing-options/ListingOptionsReducer';
import { watchListingOptionsAsyncActions } from './listing-options/ListingOptionsSagas';
import { listingsReducer } from './listings/ListingReducer';
import { watchListingsAsyncActions } from './listings/ListingSagas';
import { watchReservationsAsyncActions } from './reservations/ReservationsSagas';
import { searchReducer } from './search/SearchReducer';
import { userReducer } from './user/UserReducer';
import { watchUserAsyncActions } from './user/UserSagas';

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
  userReducer: userReducer,
  listingOptionsReducer: listingOptionsReducer,
  listingsReducer: listingsReducer,
  searchReducer: searchReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      thunk: false,
    }).concat(sagaMiddleware),
});

sagaMiddleware.run(watchUserAsyncActions);
sagaMiddleware.run(watchListingOptionsAsyncActions);
sagaMiddleware.run(watchListingsAsyncActions);
sagaMiddleware.run(watchReservationsAsyncActions);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
